import type { Components } from '@mui/material/styles';

export default function MuiStepIcon(): Components['MuiStepIcon'] {
  return {};
}
